import { base64ToArray, arrayBufferToBase64, handleCeremonyError } from "./utils";
import { AbortControllerService } from "./abort_controller";

export const RegistrationHook = {
    mounted() {
        const registrationButton = document.getElementById("registration-component");
        const reregisterButton = document.getElementById("reregister_button");

        registrationButton?.addEventListener("click", async (event) => {
            this.pushEventTo(this.el, "generate_registration_challenge", {}, (reply, ref) => {
                this.register_new_challenge(reply);
            });
        });

        reregisterButton?.addEventListener("click", async (event) => {
            console.log("reregister button clicked");
            this.pushEventTo(this.el, "generate_registration_challenge", {}, (reply, ref) => {
                this.register_new_challenge(reply);
            });
        });
    },

    async register_new_challenge(challenge) {
        try {
            const challengeArray = base64ToArray(challenge.challenge);

            challenge.user.id = base64ToArray(challenge.user.id).buffer;

            const publicKey = {
                attestation: challenge.attestation,
                authenticatorSelection: {
                    authenticatorAttachment: "platform",
                    requireResidentKey: challenge.requireResidentKey,
                },
                challenge: challengeArray.buffer,
                excludeCredentials: challenge.excludeCredentials,
                pubKeyCredParams: [
                    { alg: -7, type: "public-key" },
                    { alg: -257, type: "public-key" },
                ],
                rp: challenge.rp,
                timeout: challenge.timeout,
                user: challenge.user,
            };

            const credential = await AbortControllerService.run((signal) =>
                navigator.credentials.create({ publicKey, signal }),
            );

            const { rawId, response, type } = credential;
            const { attestationObject, clientDataJSON } = response;
            const attestation64 = arrayBufferToBase64(attestationObject);
            const clientData = Array.from(new Uint8Array(clientDataJSON));
            const rawId64 = arrayBufferToBase64(rawId);

            // Awaited so a disconnected socket is reported as the credential we
            // failed to hand back, rather than as a bare unhandled rejection.
            await this.pushEventTo(this.el, "registration-attestation", {
                attestation64,
                clientData,
                rawId64,
                type,
            });
        } catch (error) {
            handleCeremonyError(error, this);
        }
    },
};
